const navWrapper = document.querySelector('.school-file-nav-wrapper');
const navOuter = document.querySelector('.school-file-nav-outer');

const checkScrollEnd = () => {
    const { scrollLeft, scrollWidth, clientWidth } = navWrapper;

    if (scrollLeft + clientWidth >= scrollWidth - 1) {
        navOuter?.classList.add('reach-end');
    } else {
        navOuter?.classList.remove('reach-end');
    }
};

navWrapper?.addEventListener('scroll', checkScrollEnd);
